import { Roles } from "../../constants/roles";
import { FormBase } from "../../util/form-base-form";

class SNSPreviewLiveForm extends FormBase {
    public getClosestLinksPanel(root: Event | EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(root, `[data-role="${Roles.SNS_LINKS_PANEL}"]`, HTMLElement);
    }

    public getPreviewThumb(root: ParentNode): HTMLImageElement | null {
        return this.queryElement(root, `[data-role="${Roles.SNS_PREVIEW_THUMB}"]`, HTMLImageElement);
    }

    public getOgpPreviewCard(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.OGP_PREVIEW_CARD}"]`, HTMLElement);
    }
}

const snsPreviewLiveForm = new SNSPreviewLiveForm();

export { snsPreviewLiveForm };
